import React from 'react';

import { Grid } from 'semantic-ui-react';
import LinkContent from './LinkContent';

export default class CardNavigationItem extends React.Component {
  getColumnStyle(type, value) {
    const { height, rounded } = this.props;

    const baseStyle = {
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      height,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      textAlign: 'center',
      verticalAlign: 'middle',
      padding: '1em',
      borderRadius: `${rounded ? '8px' : '0'}`,
    };

    return type === 'image'
      ? { ...baseStyle, backgroundImage: `url('${value}')` }
      : { ...baseStyle, backgroundColor: value };
  }

  renderImageColumn() {
    const { internal, slug, as, gatsbyLink, background, type, gutter, height } = this.props;
    const columnStyle = this.getColumnStyle(type, background);
    const bodyStyle = gutter
      ? columnStyle
      : {
          textAlign: 'center',
          verticalAlign: 'middle',
          display: 'flex',
          alignItems: 'center',
          height,
          width: '100%',
        };
    const body = <div style={bodyStyle} />;
    return (
      <Grid.Column key={slug} style={!gutter ? columnStyle : {}}>
        <LinkContent internal={internal} slug={slug} body={body} as={as} gatsbyLink={gatsbyLink} />
      </Grid.Column>
    );
  }

  renderLabelColumn() {
    const {
      internal,
      slug,
      as,
      gatsbyLink,
      background,
      content,
      type,
      gutter,
      height,
    } = this.props;
    const columnStyle = this.getColumnStyle(type, background);
    const bodyStyle = gutter
      ? columnStyle
      : {
          textAlign: 'center',
          verticalAlign: 'middle',
          display: 'flex',
          alignItems: 'center',
          height,
          width: '100%',
        };
    return (
      <Grid.Column key={slug} style={!gutter ? columnStyle : {}}>
        <LinkContent
          internal={internal}
          slug={slug}
          body={content}
          as={as}
          gatsbyLink={gatsbyLink}
          style={bodyStyle}
        />
      </Grid.Column>
    );
  }

  render() {
    const { type } = this.props;
    return type === 'image' ? this.renderImageColumn() : this.renderLabelColumn();
  }
}
